// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1AOLu","rootCenter":"LoadMoreObserver_rootCenter__3ksmf","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2nLDR"};